import React from "react"
import { Tooltip } from "antd"
import { MediumText } from "@/UI"
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

const ApiSettingsTooltip: React.FC<{}> = () => {
  const { t } = useTranslation()
  return (
    <div className="flex w-fit space-x-2 mb-1 items-center">
      <MediumText>{t("profile.ProviderSettings.apiSettings")}</MediumText>
      <Tooltip
        title={
          "We will use our API keys and contract with this 3PL by default, if you want to use your own disable the toggle and input your  keys. Then, the prices will be yours and you will get directly bill from the 3PL."
        }
        color="black"
        overlayInnerStyle={{ padding: "1em" }}
      >
        <FontAwesomeIcon icon={faExclamationCircle} color="gray" className="cursor-pointer" />
      </Tooltip>
    </div>
  )
}

export default ApiSettingsTooltip
